
  import { WINNERS } from '@/constants/awards';
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters('provider', { provider: 'get' }),
      awards () {
        return this.provider ? WINNERS[this.provider.slug] : null;
      }
    }
  };
